import { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Container, Box, Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useSendCodeForEnrollMutation } from '../../redux/services/SendCodeForEnroll/SendCodeForEnroll';

import { useStyles } from './style';

export const NotEnrolledSMS = () => {
  const classes = useStyles();
  const history = useHistory();
  const profile = useSelector((state) => state.profile.profilInfo);
  const [sendCodeForEnrollApi, {
    isError: enrollError, isSuccess: enrollSuccess, reset: enrollReset, isLoading
  }] = useSendCodeForEnrollMutation();
  const { enqueueSnackbar } = useSnackbar();
  const errorSendCodeForEnrollApi = useRef(false);

  useEffect(() => {
    if (errorSendCodeForEnrollApi.current) {
      enqueueSnackbar('Error in resending OTP !!', { variant: 'error' });
    }
    errorSendCodeForEnrollApi.current = false;
  }, [errorSendCodeForEnrollApi.current]);

  if (enrollSuccess) {
    history.push('/phone-verification');
    enrollReset();
  }

  if (enrollError) {
    errorSendCodeForEnrollApi.current = true;
    enrollReset();
  }

  const tryAgainHandler = async () => {
    let phOnlyDigits = profile.Phone.replace(/\D/g, '');
    if (phOnlyDigits.length >= 11) {
      phOnlyDigits = phOnlyDigits.substring(1);
    }
    await sendCodeForEnrollApi({
      donorId: profile.Id,
      phoneNumer: phOnlyDigits
    });
  };

  const proceedWithoutEnrollingHandler = () => {
    if (profile.InsuranceCardPhotoFront && profile.InsuranceCardPhotoBack) {
      history.push('/card-verify');
    } else {
      history.push('/card-view');
    }
  };

  return (
    <Container maxWidth="md" className={classes.notEnrolledContainer}>
      <Box className={classes.notEnrolledContent}>
        <Box className={classes.textWrap}>
          <Box className={classes.semiBoldText}>You will not be enrolled for SMS notifications until your phone number is verified. </Box>
          <Box className={classes.normalText}>You can enroll in notifications later by visiting <Box className={classes.normalBoldText}>avertext.com</Box></Box>
        </Box>
        <Box className={classes.notEnrolledBtnWrap}>
          <Button onClick={proceedWithoutEnrollingHandler} className={`${classes.proceedBtn} ${classes.notEnrolledBtn}`} variant="contained" color="primary">
            Proceed without Enrolling
          </Button>
          <LoadingButton className={`${classes.tryAgainBtn} ${classes.notEnrolledBtn}`} variant="contained" color="secondary" onClick={tryAgainHandler} loading={isLoading}>
            Try Again
          </LoadingButton>
        </Box>
      </Box>
    </Container>
  );
};
